export default __webpack_public_path__ + "static/media/ico_down.efd3e0cc.svg";